import { getVehiclePartsQueryParamsType } from '@/common/queries/selections/vehicleParts/getVehiclePartsQuery.type';
import { getVehiclePartsQueryFunction } from '@/common/queries/selections/vehicleParts/getVehiclePartsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getVehiclePartsQueryOptions = (
  params: getVehiclePartsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['VehiclePart', params],
    queryFn: () => getVehiclePartsQueryFunction(params),
    select: (data) =>
      data.map((item) => ({
        label: item.complete_name,
        value: item.complete_name,
        enNameOrId: item.id,
      })),
  });
};
